
export const API_DOMAIN = window.location.protocol + '//' + window.location.hostname
// const findCookie = (key) => {
//     const pair = document.cookie.split('; ').find(part => part.indexOf(key + '=') === 0)
//     if (pair === undefined) {
//         return ''
//     }
//     return pair.split('=')[1]
// }

export const AXIOS_CONFIG = {
    baseURL: API_DOMAIN + '/api/v1/',
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Accept-Language': 'ru-RU, ru;q=0.9, en-US;q=0.8, en;q=0.7'
    }
}

// if (process.env.NODE_ENV === 'production') {
//     AXIOS_CONFIG.headers['X-Sms-Token'] = findCookie('sms-token');
// }
